export default __webpack_public_path__ + "signup-backdrop-client-tablet.3035ce4d.jpg";